import * as actionTypes from "../constants/actionTypes";

const initialState = {
    overrideMode: false
};

/**
 * Structure of order store:
 * - overrideMode {Boolean}     - if true, IG order client is running forced
 */
export const intergammaMachineReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.INTERGAMMA_SET_OVERRIDE_MODE:
            return {
                ...initialState,
                overrideMode: action.payload.active
            };
        case actionTypes.WEBSOCKET_CLOSED:
            return initialState;
        default:
            return state;
    }
};
